import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import { Col, Row } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import Expanded from '../../components/Expanded'
import Compact from '../../components/Compact'

import './index.css'

import { LIST_VIEW } from '../../constants'

@observer
class HitList extends Component {
  renderIsLoading() {
    return (
      <FontAwesome
        style={{ marginLeft: '2em' }}
        name="circle-o-notch"
        spin
        size="3x"
      />
    )
  }

  render() {
    const { isLoading, displayMode } = this.props.store
    const { items, dataClassLabels } = this.props.store.itemStore

    const expanded = <Expanded items={items} store={this.props.store} />
    const compact = <Compact items={items} store={this.props.store} />

    const listComp = displayMode === LIST_VIEW ? expanded : compact
    const dc = items.length > 0 && items[0] ? items[0].data_type : ''
    const label = dataClassLabels[dc]
    const typeRow =
      displayMode === LIST_VIEW ? null : (
        <Row className="list-group-item-heading tableheadrow">
          <Col xs={12} className={dc + ' tableheadcol'}>
            <div className="tablehead">{label + ' Results'}</div>
          </Col>
        </Row>
      )

    return (
      <Row>
        <Col xs={12}>
          <div className="list-group">
            {!isLoading && typeRow}
            {isLoading && this.renderIsLoading()}
            {!isLoading && listComp}
          </div>
        </Col>
      </Row>
    )
  }
}

HitList.propTypes = {
  store: PropTypes.object.isRequired,
}

export default HitList
